<app-pup-selection *ngIf="!loading" [supplierPupSelectionConfig]="pupSelectionConfig">
</app-pup-selection>

<div *ngIf="loading" class="loader">
  <span>
    <span class="spinner spinner-slow" role="status"></span>
    &nbsp;Loading...
  </span>
</div>
